export default class MyCarsSubview {
  constructor(parent) {
      this.parent = parent;
      this.el = parent.el.querySelector('.my-cars-subview');    
      this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
      this.template = _.template(parent.el.querySelector('#service-plan-my-car-template').innerHTML.replaceAll('\\', ''), this.templateSettings);
      this.carsEl = this.el.querySelector('.my-cars');
      this.loader = this.el.querySelector('.form_loader');
  }

  show() {
    this.el.classList.remove('hide');
  }

  hide() {
    this.el.classList.add('hide');
  }

  async populate(cars) {
    this.showLoader();
    this.render(cars);
    this.bindCTA(cars);
    this.hideLoader();
  }

  bindCTA(cars) {
    const connectedCarCTAs = this.el.querySelectorAll('.connected-car-cta');

    if (connectedCarCTAs.length > 0) {
      connectedCarCTAs.forEach(button => {
        button.addEventListener('click', (e)=> {
          const selectedVin = button.dataset.vin;
          this.onSelect(selectedVin, cars);
        });
      });
    }
  }

  render(cars) {
    this.carsEl.innerHTML = this.template({ cars });
  }

  onSelect(selectedVin, cars) {
    const result = cars.find((car) => car.vehicle.vin === selectedVin);
    this.parent.result = result; //Set data of chosen car into parent result to be rendered on results screen.
  }

  showLoader() {
    this.loader.classList.remove('hide');
  }

  hideLoader() {
    this.loader.classList.add('hide');
  }
}
